import { render, staticRenderFns } from "./MainView.vue?vue&type=template&id=52c015c8&"
import script from "./MainView.vue?vue&type=script&lang=js&"
export * from "./MainView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports